import React, { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const defaultValues = {
  format: 'MM/DD/YYYY',
  minDate: '01/01/2020',
};

const errrorMessage = {
  minDate: 'Check allowed dates',
  maxDate: 'Check allowed dates',
  invalidDate: 'Valid dates only accepted',
  disableFuture: 'Future dates are not allowed',
};

const CustomDatePicker = (props) => {
  const [error, updateError] = useState(null);
  const [selectedDate, updateSelectedDate] = useState(null);

  useEffect(() => {
    if (props.value) updateSelectedDate(props.value);
    else updateSelectedDate(null);
  }, [props]);

  useEffect(() => {
    if(Boolean(props.minDate) && Boolean(props.value) && dayjs(props.minDate).isAfter(dayjs(props.value))) {
      updateError("minDate");
      typeof props.onError == 'function' && props.onError("minDate");
    }
  }, [props.value]);
  
  const handleDateChange = (date, error) => {
    // if (error.validationError == null) {
      let formattedDate = dayjs(date).format(
        props.format || defaultValues.format
      );
      updateError(null);
      updateSelectedDate(formattedDate);
      typeof props.onChange == 'function' && props.onChange(formattedDate, date);
    // }
  };
  const handleError = (error) => {
    updateError(error);
    typeof props.onError == 'function' && props.onError(error);
  };

  return (
    <div className="x-date-picker">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          format={props.format || defaultValues.format}
          label={props.label}
          variant="standard"
          value={selectedDate ? dayjs(selectedDate) : null}
          onChange={handleDateChange}
          onError={handleError}
          disableFuture={Object.hasOwn(props, "disableFuture") ? props.disableFuture : true}
          showDaysOutsideCurrentMonth={true}
          disabled={props.disabled}
          {...(props.hasOwnProperty("minDate") ?  {minDate: dayjs(props.minDate).endOf('day') } : {})}
          {...(props.hasOwnProperty("maxDate") ?  {maxDate: dayjs(props.maxDate).endOf('day') } : {})}
          {...(props.hasOwnProperty("views") && props.hasOwnProperty("openTo") ? {views: props.views, openTo: props.openTo} : {views: ['year', 'month', 'day'], openTo: 'day'})}
          slotProps={{
            textField: {
              helperText: errrorMessage[error],
              variant: 'standard',
            },
            popper: {
              sx: {
                "& .MuiPaper-root": {
                  backgroundColor: "var(--bg-popover)",
                  borderRadius: "12px",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.35) !important",
                },
        
                /* Header (Month + arrows) */
                "& .MuiPickersCalendarHeader-root, .MuiPickersCalendarHeader-switchViewButton": {
                  color: "var(--icon-primary) !important",
                },
        
                "& .MuiPickersArrowSwitcher-button": {
                  color: "var(--icon-primary) !important",
                },
        
                /* Weekday labels */
                "& .MuiDayCalendar-weekDayLabel": {
                  color:
                  "var(--text-grey) !important",
                  fontWeight: 500,
                },
        
                /* Day cells */
                "& .MuiPickersDay-root, .MuiPickersYear-yearButton": {
                  color:
                  "var(--text-primary) !important",
                  borderRadius: "16px",
        
                  "&:hover": {
                    backgroundColor:
                    "rgba(0, 0, 0, 0.04) !important",
                  },
                },
        
                /* Selected day */
                "[data-theme = 'dark'] & .Mui-selected": {
                  backgroundColor: "var(--hti-magenta-dark) !important",
                  color: "var(--text-primary)",
                  "&:hover": {
                    backgroundColor:
                      "var(--hti-magenta-dark) !important",
                  },
                },
        
                /* Today */
                "& .MuiPickersDay-today": {
                  border: "1px solid var(--border-dark) !important",
                },
        
                /* Disabled days */
                "& .Mui-disabled, .Mui-disabled:not(.Mui-selected)": {
                  color: "var(--text-disabled) !important",
                },
              },
            },        
          }}
          sx={{
            width: '120px',
            '& input': { fontSize: '1rem', color: "var(--text-primary)" },
            '& svg': { fontSize: '1rem' },
            '& label': { color: 'var(--text-grey)' },
            '& button': { padding: '5px 5px 5px 5px', margin: 'unset', color: "var(--icon-primary)" },
            '& > div': { display: 'flex', justifyContent: 'space-between' },
            '& > div:before': { borderColor: "var(--border-dark)" },
            '& > div:hover:before': { borderColor: "var(--text-primary) !important" },
            '& p': { width: 'max-content', position: 'absolute', top: '42px'},
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CustomDatePicker;
